import React, { useEffect, useRef, useState } from 'react';
import { RadialGauge } from 'canvas-gauges';
import Panel from "../components/Panel";

// Source link
// https://canvas-gauges.com/documentation/examples/

const Compass = ({ data }) => {
  const gaugeRef = useRef(null);
  const [gauge, createGauge] = useState({});

  useEffect(() => {
    const newGauge = new RadialGauge({
      renderTo: gaugeRef.current,
      title: 'Compass',
      unit: '° Magnetic',
      colorTitle: 'white',
      minValue: 0,
      maxValue: 360,
      majorTicks: [
          "N",
          "NE",
          "E",
          "SE",
          "S",
          "SW",
          "W",
          "NW",
          "N"
      ],
      minorTicks: 22,
      ticksAngle: 360,
      startAngle: 180,
      strokeTicks: false,
      highlights: false,
      colorPlate: "#3a3",
      colorMajorTicks: "#f5f5f5",
      colorMinorTicks: "#ddd",
      colorNumbers: "#ccc",
      colorNeedle: "red",
      colorNeedleEnd: "red",
      valueBox: true,
      valueDec: 0,
      valueTextShadow: false,
      colorCircleInner: "#fff",
      colorNeedleCircleOuter: "#ccc",
      needleCircleSize: 15,
      needleCircleOuter: false,
      animationRule: "linear",
      animatedValue: true,
      needleType: "line",
      needleStart: 75,
      needleEnd: 99,
      needleWidth: 3,
      borders: true,
      borderInnerWidth: 0,
      borderMiddleWidth: 0,
      borderOuterWidth: 10,
      colorBorderOuter: "#ccc",
      colorBorderOuterEnd: "#ccc",
      colorNeedleShadowDown: "#222",
      borderShadowWidth: 0,
      animationTarget: "plate",
      animationDuration: 1500,
      value: data?.heading,
      // animateOnInit: true
    });
    newGauge.draw();

    createGauge(newGauge);

    // return () => {
    //   newGauge.destroy();
    // };
  }, []);

  gauge.value = data?.heading;

  return (
    <Panel>
      <canvas ref={gaugeRef} style={{padding: 10, width: '100%', height: '100%'}} />
    </Panel>
  );
};

export default Compass;